<template>
  <div class="home-page container-md">
    <h2>Upload 上传</h2>
    <p>上传是将信息（网页、文字、图片、视频等）通过网页或者上传工具发布到远程服务器上的过程。</p>

    <h4>何时使用</h4>
    <p>当需要上传一个或一些文件时。支持自定义检查，三种状态模版，暴露成功失败事件</p>

    <h4>演示</h4>
    <uploader
      action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
      :beforeUpload="commonUploadCheck"
      class="d-flex align-items-center justify-content-center bg-light text-secondary w-100 my-4 p-4"
    >
    </uploader>
    <h4 class="mt-4">template代码</h4>
    <pre class="language-html">
      <code v-html="highlightedCode"></code>
    </pre>
    <h4 class="mt-4">setup代码</h4>
    <pre class="language-js">
      <code v-html="highlightedCode2"></code>
    </pre>
    <h4>Upload 属性和事件</h4>
    <props-table :props="props"></props-table>
  </div>
</template>

<script>
import Prism from 'prismjs'
import Uploader from '../components/Uploader.vue'
import PropsTable from '../components/PropsTable.vue'
import { commonUploadCheck } from '../helper'
export default {
  data () {
    return {
      props: [
        { name: 'action', type: 'string', desc: '上传的后端 URL' },
        { name: 'beforeUpload', type: 'function', desc: '(file: File) => boolean' },
        { name: 'uploaded', type: 'object', desc: '上传完成后回传的数据，可以供自定义模版使用' },
        { name: 'file-uploaded', type: '事件', desc: '回调函数 (data: any) => void, 成功上传以后发送的事件' },
        { name: 'file-uploaded-error', type: '事件', desc: '回调函数 (error: Error) => void, 上传失败以后发送的事件' }
      ],
      code: `
    <uploader
      action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
      :beforeUpload="commonUploadCheck"
      class="d-flex align-items-center justify-content-center bg-light text-secondary w-100 my-4 p-4"
    >
    </uploader>`,
      code2: `
export const commonUploadCheck = (file: File) => {
  const result = beforeUploadCheck(file, { format: ['image/jpeg', 'image/png'], size: 1 })
  const { passed, error } = result
  if (error === 'format') {
    createMessage('上传图片只能是 JPG/PNG 格式!', 'error')
  }
  if (error === 'size') {
    createMessage('上传图片大小不能超过 1Mb', 'error')
  }
  return passed
}`
    }
  },
  computed: {
    highlightedCode () {
      return Prism.highlight(this.code, Prism.languages.html)
    },
    highlightedCode2 () {
      return Prism.highlight(this.code2, Prism.languages.javascript)
    }
  },
  components: {
    Uploader,
    PropsTable
  },
  setup (props, context) {
    return {
      commonUploadCheck
    }
  }
}
</script>
